import { SYNC_FACE_ID_SUCCESS, SYNC_FACE_ID_ERROR, SYNC_FACE_ID_REQUEST } from './constants';

export const syncFaceIdRequest = (branchId: string) => ({
  type: SYNC_FACE_ID_REQUEST,
  payload: { branchId },
});

export const syncFaceIdError = (error: Error | null) => ({
  type: SYNC_FACE_ID_ERROR,
  payload: error,
});

export const syncFaceIdSuccess = () => ({
  type: SYNC_FACE_ID_SUCCESS,
});

export type Actions =
  | ReturnType<typeof syncFaceIdRequest>
  | ReturnType<typeof syncFaceIdError>
  | ReturnType<typeof syncFaceIdSuccess>;
